<template lang="pug">
  #ReservationEdit.container-width
    h5.text-center.pt-2 修改預約
    .p-3
      .mb-2
        ValidationObserver(
          ref="form"
          tag="form"
          @submit.stop.prevent="submitHandler"
        )
          b-form-group
            ValidationProvider(
              rules="required",
              ref="inputValName"
            )
              label(
                for="name"
              )
                code *
                span 顧客姓名：
              b-form-input(
                id="name",
                type="text",
                required,
                trim,
                :state="validState('name')",
                v-model="form.name",
                aria-describedby="input-live-help input-name-live-feedback",
                placeholder="請輸入顧客姓名"
              )
              b-form-invalid-feedback(
                id="input-name-live-feedback"
              )
                span 此欄不可為空
          b-form-group
            ValidationProvider(
              rules="required",
              ref="inputValService",
              v-slot="{ errors }"
            )
              label(
                for="store"
              )
                code *
                span 預約服務
              b-form-select(
                id="store",
                required,
                v-model="form.service",
                :state="validState('service')",
                aria-describedby="input-live-help input-name-live-feedback",
                placeholder="請選擇預約服務"
              )
                template(
                  v-slot:first
                )
                  b-form-select-option(
                    :value="null",
                    disabled
                  ) 請選擇預約服務
                  b-form-select-option.d-none(
                    :value="''",
                    disabled
                  ) 請選擇預約服務
                b-form-select-option(
                  v-for="(service,index) in serviceOptions",
                  :key="service.id",
                  :value="service.id"
                ) {{ service.text }}
              b-form-invalid-feedback(
                id="input-name-live-feedback"
              )
                span 此欄不可為空
          b-form-group
            ValidationProvider(
              rules="required",
              ref="inputValDate"
            )
              label(
                for="date"
              )
                code *
                span 預約日期
              b-form-datepicker(
                id="date",
                type="date",
                required,
                trim,
                :state="validState('date')",
                v-model="form.date",
                aria-describedby="input-live-help input-name-live-feedback",
                placeholder="請選擇預約日期",
                :min="dateMinLimit"
              )
              b-form-invalid-feedback(
                id="input-name-live-feedback"
              )
                span 此欄不可為空
          b-form-group
            ValidationProvider(
              rules="required",
              ref="inputValTime"
            )
              label(
                for="time"
              )
                code *
                span 預約時間
              b-form-timepicker(
                id="time",
                type="time",
                required,
                trim,
                :state="validState('time')",
                v-model="form.time",
                aria-describedby="input-live-help input-name-live-feedback",
                placeholder="請選擇預約時間"
              )
              b-form-invalid-feedback(
                id="input-name-live-feedback"
              )
                span 此欄不可為空
          b-form-group
            ValidationProvider(
              ref="inputValNote"
            )
              label(
                for="note"
              )
                span 顧客備註
              b-form-textarea(
                id="m-note",
                type="text",
                rows="3",
                v-model="form.memberNote",
                placeholder="輸入備註"
              )
          b-form-group
            ValidationProvider(
              ref="inputValNote"
            )
              label(
                for="note"
              )
                span 顧問備註
              b-form-textarea(
                id="sa-note",
                type="text",
                rows="3",
                v-model="form.saNote",
                placeholder="輸入備註"
              )
      .px-4
        .row
          .col-6
            b-button(
              block,
              variant="primary"
            )
              router-link.text-white(
                :to="{ name: 'sm-my-customer-index' }"
              ) 取消
          .col-6
            button.btn.btn-block.btn-primary(
              type="button",
              @click="submitHandler()"
            ) 確認
</template>

<script>
import { SM_MY_CUSTOMER_INDEX } from '@/router/sm/my-customer';
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'; // 檢查套件
import { required } from 'vee-validate/dist/rules';

// 獲取所有驗證條件
extend('required', {
  ...required,
  message: '此欄不可為空'
});

export default {
  name: 'MyCustomerReservationEdit',
  props: {
    userId: {
      type: [String, Number],
      required: true
    },
    id: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  mounted() {
    console.log(this.userId);
  },
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const minDate = new Date(today);
    return {
      form: {
        name: null,
        service: null,
        date: null,
        time: null,
        memberNote: null,
        saNote: null
      },
      serviceOptions: [
        { id: '1', text: '產品諮詢' },
        { id: '2', text: '會員業務' }
      ],
      dateMinLimit: minDate
    };
  },
  methods: {
    // 檢查欄位
    validState(key) {
      const vm = this;
      if (vm.form[key] !== null) {
        return this.form[key] ? true : false;
      }
      return null;
    },
    // 送出表單
    async submitHandler() {
      const vm = this;
      const isValid = await this.$refs.form.validate();
      console.log(isValid);
      if (!isValid) {
        if (vm.form.name === null) {
          vm.form.name = '';
        }
        if (vm.form.service === null) {
          vm.form.service = '';
        }
        if (vm.form.date === null) {
          vm.form.date = '';
        }
        if (vm.form.time === null) {
          vm.form.time = '';
        }
        vm.$swal.fire({
          icon: 'error',
          title: '請填妥必填欄位或格式輸入錯誤'
        });
      } else {
        // TODO: 打AP，確認有無重複使用者
        vm.$swal.fire({
          title: '表單送出中，請稍候',
          allowOutsideClick: false,
          willOpen: () => {
            vm.$swal.showLoading();
          }
        });
        setTimeout(() => {
          vm.$swal.fire({
            title: '修改預約',
            html: '已成功送出預約修改<br/>請靜待美容顧問確認時間',
            showCancelButton: false,
            confirmButtonText: 'OK',
            reverseButtons: true,
            customClass: {
              confirmButton: 'btn btn-primary px-5'
            }
          }).then(() => {
            vm.$router.push({
              name: SM_MY_CUSTOMER_INDEX,
              params: {
                userId: vm.userId
              }
            });
          });
        }, 2000);
      }
    }
  }
};
</script>

<style>

</style>
